import { render, staticRenderFns } from "./compare.vue?vue&type=template&id=1ff709eb"
import script from "./compare.vue?vue&type=script&lang=js"
export * from "./compare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports